// extracted by mini-css-extract-plugin
module.exports = {"sorting-menu-container":"SortingMenuDesktop_sorting-menu-container__8Bq_B"};